// extracted by mini-css-extract-plugin
export var deleteModal = "_fa-0";